import { BaseConfig } from '@types'

//File di configurazione generale
export const config: BaseConfig = {
  endpoint: `https://infocamere.dev.metamorphosis.cloud/api/infocamereml`, // 'http://localhost:3200/infocamereml',
  landingPage: '/correlation',
  dataSet: {
    indexes: [{ label: 'Infocamere', value: 'infocamere' }],
    comparisonIndex: 'infocamere_confronto',
  },
  iconColorDark: 'white',
  iconColorLight: 'black',
  filters: {
    defaultMetrics: {
      label: 'utile_a_nuovo_anno_prec',
      value: 'utile_a_nuovo_anno_prec',
    },
    regions: [
      { label: '', value: '' },
      { label: 'Abruzzo', value: 'ABRUZZO' },
      { label: 'Basilicata', value: 'BASILICATA' },
      { label: 'Calabria', value: 'CALABRIA' },
      { label: 'Campania', value: 'CAMPANIA' },
      { label: 'Emilia Romagna', value: 'EMILIA ROMAGNA' },
      { label: 'Friuli Venezia Giulia', value: 'FRIULI VENEZIA GIULIA' },
      { label: 'Lazio', value: 'LAZIO' },
      { label: 'Liguria', value: 'LIGURIA' },
      { label: 'Lombardia', value: 'LOMBARDIA' },
      { label: 'Marche', value: 'MARCHE' },
      { label: 'Molise', value: 'MOLISE' },
      { label: 'Piemonte', value: 'PIEMONTE' },
      { label: 'Puglia', value: 'PUGLIA' },
      { label: 'Sardegna', value: 'SARDEGNA' },
      { label: 'Sicilia', value: 'SICILIA' },
      { label: 'Toscana', value: 'TOSCANA' },
      { label: 'Trentino Alto Adige', value: 'TRENTINO ALTO ADIGE' },
      { label: 'Umbria', value: 'UMBRIA' },
      { label: "Valle D'Aosta", value: "VALLE D'AOSTA" },
      { label: 'Veneto', value: 'VENETO' },
    ],
    years: [
      { label: '', value: '' },
      { label: '2017', value: 2017 },
      { label: '2018', value: 2018 },
      { label: '2019', value: 2019 },
      { label: '2020', value: 2020 },
      { label: '2021', value: 2021 },
      { label: '2022', value: 2022 },
    ],
    ateco: [
      { label: '', value: '' },
      {
        label: 'A AGRICOLTURA, SILVICOLTURA E PESCA',
        value: 'A AGRICOLTURA, SILVICOLTURA E PESCA',
      },
      {
        label: 'B ESTRAZIONE DI MINERALI DA CAVE E MINIERE',
        value: 'B ESTRAZIONE DI MINERALI DA CAVE E MINIERE',
      },
      {
        label: "C ATTIVITA' MANIFATTURIERE",
        value: "C ATTIVITA' MANIFATTURIERE",
      },
      {
        label:
          'D FORNITURA DI ENERGIA ELETTRICA, GAS, VAPORE E ARIA CONDIZION...',
        value:
          'D FORNITURA DI ENERGIA ELETTRICA, GAS, VAPORE E ARIA CONDIZION...',
      },
      {
        label:
          "E FORNITURA DI ACQUA; RETI FOGNARIE, ATTIVITA' DI GESTIONE DEI...",
        value:
          "E FORNITURA DI ACQUA; RETI FOGNARIE, ATTIVITA' DI GESTIONE DEI...",
      },
      { label: 'F COSTRUZIONI', value: 'F COSTRUZIONI' },
      {
        label:
          "G COMMERCIO ALL'INGROSSO E AL DETTAGLIO; RIPARAZIONE DI AUTOVE...",
        value:
          "G COMMERCIO ALL'INGROSSO E AL DETTAGLIO; RIPARAZIONE DI AUTOVE...",
      },
      {
        label: 'H TRASPORTO E MAGAZZINAGGIO',
        value: 'H TRASPORTO E MAGAZZINAGGIO',
      },
      {
        label: "I ATTIVITA' DEI SERVIZI DI ALLOGGIO E DI RISTORAZIONE",
        value: "I ATTIVITA' DEI SERVIZI DI ALLOGGIO E DI RISTORAZIONE",
      },
      {
        label: 'J SERVIZI DI INFORMAZIONE E COMUNICAZIONE',
        value: 'J SERVIZI DI INFORMAZIONE E COMUNICAZIONE',
      },
      {
        label: "K ATTIVITA' FINANZIARIE E ASSICURATIVE",
        value: "K ATTIVITA' FINANZIARIE E ASSICURATIVE",
      },
      { label: "L ATTIVITA' IMMOBILIARI", value: "L ATTIVITA' IMMOBILIARI" },
      {
        label: "M ATTIVITA' PROFESSIONALI, SCIENTIFICHE E TECNICHE",
        value: "M ATTIVITA' PROFESSIONALI, SCIENTIFICHE E TECNICHE",
      },
      {
        label:
          'N NOLEGGIO, AGENZIE DI VIAGGIO, SERVIZI DI SUPPORTO ALLE IMPRE...',
        value:
          'N NOLEGGIO, AGENZIE DI VIAGGIO, SERVIZI DI SUPPORTO ALLE IMPRE...',
      },
      { label: 'P ISTRUZIONE', value: 'P ISTRUZIONE' },
      {
        label: "Q SANITA' E ASSISTENZA SOCIALE",
        value: "Q SANITA' E ASSISTENZA SOCIALE",
      },
      {
        label:
          "R ATTIVITA' ARTISTICHE, SPORTIVE, DI INTRATTENIMENTO E DIVERTI...",
        value:
          "R ATTIVITA' ARTISTICHE, SPORTIVE, DI INTRATTENIMENTO E DIVERTI...",
      },
      {
        label: "S ALTRE ATTIVITA' DI SERVIZI",
        value: "S ALTRE ATTIVITA' DI SERVIZI",
      },
    ],
    comparison_ateco: [
      { label: '', value: '' },
      {
        label: 'A AGRICOLTURA, SILVICOLTURA E PESCA',
        value: 'A Agricoltura, silvicoltura pesca',
      },
      {
        label: "C ATTIVITA' MANIFATTURIERE",
        value: 'C Attività manifatturiere',
      },
      {
        label:
          'D FORNITURA DI ENERGIA ELETTRICA, GAS, VAPORE E ARIA CONDIZION...',
        value: 'D Fornitura di energia elettrica, gas, vapore e aria condiz...',
      },
      {
        label:
          "E FORNITURA DI ACQUA; RETI FOGNARIE, ATTIVITA' DI GESTIONE DEI...",
        value: 'E Fornitura di acqua; reti fognarie, attività di gestione d...',
      },
      { label: 'F COSTRUZIONI', value: 'F Costruzioni' },
      {
        label:
          "G COMMERCIO ALL'INGROSSO E AL DETTAGLIO; RIPARAZIONE DI AUTOVE...",
        value: "G Commercio all'ingrosso e al dettaglio; riparazione di aut...",
      },
      {
        label: 'H TRASPORTO E MAGAZZINAGGIO',
        value: 'H Trasporto e magazzinaggio',
      },
      {
        label: "I ATTIVITA' DEI SERVIZI DI ALLOGGIO E DI RISTORAZIONE",
        value: 'I Attività dei servizi di alloggio e di ristorazione',
      },
      {
        label: 'J SERVIZI DI INFORMAZIONE E COMUNICAZIONE',
        value: 'J Servizi di informazione e comunicazione',
      },
      {
        label: "K ATTIVITA' FINANZIARIE E ASSICURATIVE",
        value: 'K Attività finanziarie e assicurative',
      },
      { label: "L ATTIVITA' IMMOBILIARI", value: 'L Attività immobiliari' },
      {
        label: "M ATTIVITA' PROFESSIONALI, SCIENTIFICHE E TECNICHE",
        value: 'M Attività professionali, scientifiche e tecniche',
      },
      {
        label:
          'N NOLEGGIO, AGENZIE DI VIAGGIO, SERVIZI DI SUPPORTO ALLE IMPRE...',
        value:
          'N Noleggio, agenzie di viaggio, servizi di supporto alle imp...',
      },
      { label: 'P ISTRUZIONE', value: 'P Istruzione' },
      {
        label: "Q SANITA' E ASSISTENZA SOCIALE",
        value: 'Q Sanità e assistenza sociale',
      },
      {
        label:
          "R ATTIVITA' ARTISTICHE, SPORTIVE, DI INTRATTENIMENTO E DIVERTI...",
        value: 'R Attività artistiche, sportive, di intrattenimento e diver...',
      },
      {
        label: "S ALTRE ATTIVITA' DI SERVIZI",
        value: 'S Altre attività di servizi',
      },
      {
        label: 'X IMPRESE NON CLASSIFICATE',
        value: 'X Imprese non classificate',
      },
    ],
    month: [
      { label: '', value: '' },
      { label: '3', value: 3 },
      { label: '6', value: 6 },
      { label: '9', value: 9 },
      { label: '12', value: 12 },
    ],
    pro_loc: [
      { label: '', value: '' },
      { label: '0', value: 0 },
      { label: '1', value: 1 },
      { label: '2', value: 2 },
      { label: '3', value: 3 },
      { label: '4', value: 4 },
      { label: '5', value: 5 },
      { label: '6', value: 6 },
      { label: '7', value: 7 },
      { label: '8', value: 8 },
      { label: '9', value: 9 },
      { label: '10', value: 10 },
      { label: '11', value: 11 },
      { label: '12', value: 12 },
      { label: '13', value: 13 },
      { label: '14', value: 14 },
      { label: '15', value: 15 },
      { label: '16', value: 16 },
      { label: '17', value: 17 },
      { label: '18', value: 18 },
      { label: '19', value: 19 },
      { label: '20', value: 20 },
      { label: '21', value: 21 },
      { label: '22', value: 22 },
    ],
    comparisonYear: [
      { label: '', value: '' },
      { label: '2019', value: '2019' },
      { label: '2020', value: '2020' },
      { label: '2021', value: '2021' },
    ],
    attributes: [
      { label: '', value: '' },
      { label: 'Addetti totali', value: 'addetti_totali' },
      {
        label: 'Valore produzione anno precedente',
        value: 'valore_produzione_anno_prec',
      },
      {
        label: 'Capitale sociale anno precedente',
        value: 'capitale_sociale_anno_prec',
      },
      {
        label: 'Riserve ba2 ba7 anno precedente',
        value: 'riserve_ba2_ba7_anno_prec',
      },
      {
        label: 'Utile perdita a nuovo anno precedente',
        value: 'utile_perdita_a_nuovo_anno_prec',
      },
      {
        label: 'Utile perdita anno precedente',
        value: 'utile_perdita_anno_prec',
      },
    ],
    geoAttributes: [
      { label: '', value: '' },
      { label: 'Addetti totali', value: 'addetti_totali' },
      {
        label: 'Valore produzione anno precedente',
        value: 'valore_produzione_anno_prec',
      },
      {
        label: 'Capitale sociale anno precedente',
        value: 'capitale_sociale_anno_prec',
      },
      {
        label: 'Riserve ba2 ba7 anno precedente',
        value: 'riserve_ba2_ba7_anno_prec',
      },
      {
        label: 'Utile perdita anno precedente',
        value: 'utile_perdita_anno_prec',
      },
      {
        label: 'Utile a nuovo anno precedente',
        value: 'utile_a_nuovo_anno_prec',
      },
    ],
    aggregations: [
      { label: '', value: '' },
      { label: 'Average', value: 'avg' },
      { label: 'Minimum', value: 'min' },
      { label: 'Maximum', value: 'max' },
      { label: 'Count', value: 'value_count' },
      { label: 'Sum', value: 'sum' },
    ],
  },
  NLPTopic: [
    { label: 'Turismo', value: 'TURISMO' },
    { label: 'Servizi', value: 'servizi' },
    { label: 'Industria', value: 'industria' },
    { label: 'Commercio', value: 'commercio' },
    { label: 'Agricoltura/Pesca', value: 'AGRICOLTURA/PESCA' },
  ],
}
